(function ($)
  { "use strict"
 var productsCarousel;

var productsCarouselTimeout;

$('.bestseller-carousel').on('mouseenter', function() {
    console.log('STOPPPING!')
    window.clearTimeout(productsCarouselTimeout);
    productsCarousel.trigger('stop.owl.carousel');
})

$('.bestseller-carousel').on('mouseleave', function() {
    window.clearTimeout(productsCarouselTimeout);
    productsCarouselTimeout = window.setTimeout(function() {
        console.log('Next!!!')
        productsCarousel.trigger('next.owl.carousel');
    }, 3000)
})

productsCarousel = $('.bestseller-carousel');
    productsCarousel.owlCarousel({
		loop:true,
		nav:false,
        margin:40,
		dots:true,
        center: false,
         autoplayHoverPause: true,
            autoplayTimeout: 3000,

		autoplay: true,
		responsive:{
			0:{
				items:1
			},
			768:{
				items:1
			},
			1000:{
				items:2
			}
		}
	});


   
   
baguetteBox.run('.baguetteBox', {
  animation: 'fadeIn',
  noScrollbars: true
});



   
   // :: 7.0 Tooltip Active Code
   

    $(function () {
        $('[data-toggle="popover"]').popover({html:true})
      })

    $('[data-toggle="tooltip"]').tooltip({html:true})





       var seen = $('.owl-channels');
    seen.owlCarousel({
		loop:true,
		nav:false,
        margin:40,
		dots:true,
        center: false,
         autoplayHoverPause: true,
		autoplay: true,
		responsive:{
			0:{
				items:1
			},
			400:{
				items:3
			},
			1000:{
				items:6
			}
		}
	});
  

    


       var review = $('.testimonial-carousel');
    review.owlCarousel({
		loop:true,
		nav:false,
        margin:40,
		dots:true,
        autoplayHoverPause: true,
        center: true,
		autoplay: true,
		responsive:{
			0:{
				items:1
			},
			768:{
				items:2
			},
			1000:{
				items:2
			}
		}
	});


var bestSellers = $('.owl_products_bestSellers');
  bestSellers.owlCarousel({
		loop:true,
		nav:false,
    margin:40,
		dots:true,
    autoplayHoverPause: true,
		autoplay: true,
		responsive:{
			0:{
				items:1
			},
			768:{
				items:2
			},
			1000:{
				items:3
			}
		}
	});

  // service_slider js code
  var service = $('.service_slider');
  if (service.length) {
    service.owlCarousel({
      items: 1,
      loop: true,
      dots: false,
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: 5000,
      animateOut: 'fadeOut',
      nav: true,
      smartSpeed: 2000,
      navText: [
        '<i class="fa-solid fa-angle-left"></i>',
        '<i class="fa-solid fa-angle-right"></i>'
      ],
      responsive: {
        0: {
          nav: false,
        },
        768: {
          nav: true,
        },
        992: {
          nav: true,
        }
      }
    });
  }

  var service2 = $('.service_slider_2');
  if (service2.length) {
    service2.owlCarousel({
      items: 1,
      loop: true,
      dots: false,
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: 5000,
      animateOut: 'fadeOut',
      nav: false,
      smartSpeed: 2000,
      navText: [
        '<i class="fa-solid fa-angle-left"></i>',
        '<i class="fa-solid fa-angle-right"></i>'
      ]
    });
  }


 

  var clients = $('.owl-logos-clients');
    clients.owlCarousel({
      loop:true,
      nav:false,
      margin:40,
      dots:true,
      autoplayHoverPause: true,
      autoplay: true,
      autoplayTimeout: 2000,
      responsive:{
        0:{
          items:1
        },
        768:{
          items:2
        },
        1000:{
          items:3
        }
      }
    });
    $('.container_logo').mouseover(function(){
      clients.trigger('stop.owl.autoplay')
  })
  $('.container_logo').mouseout(function(){
    clients.trigger('play.owl.autoplay',[3000])
  })




 $('.mega-menu__list > li:nth-child(1) > ul:nth-child(2) > li:nth-child(1) > a:nth-child(1)').on('click', function() {
      $('#myModal').modal('toggle');
})
/*$('.mega-menu__list > li:nth-child(2) > ul:nth-child(2) > li:nth-child(2) > a:nth-child(1)').on('click', function() {
      $('#myModal').modal('toggle');
})*/




})(jQuery);


/*Remover AOS*/
$(window).resize(function() {
  if ($(window).width() < 992) {
  $("div.col-md-4:nth-child(1)").removeAttr("data-aos");
  $("div.col-md-4:nth-child(2)").removeAttr("data-aos");
  $("footer .ml-md-4").removeAttr("data-aos");
 


  }
});


// $('#social-share').click(function(){
//   if($('.social-itens').hasClass('open') == true){
//     alert('sip')
//     $(".social-itens").removeClass("open");
//     $(".social-itens").addClass("hidden");
//   }else{
//     alert('nop')
//     $(".social-itens").addClass("open");
//     $(".social-itens").removeClass("hidden");
//   }

//   // $(".social-itens").removeClass("open");
//   // $(".social-itens").addClass("hidden");

// })



$("#social-share").hover(function () {
  $(".social-itens").addClass("open");
  $(".social-itens").removeClass("hidden");
}, 
function () {
    $(".social-itens").removeClass("open");
  $(".social-itens").addClass("hidden");
});





//
 $(window).on("scroll", function() { 
    var nav = $('#social-share');
    var nav2 = $('.fixed-shop');
    var nav3 = $('.stt-mars1');

    if ($(this).scrollTop() < 250 ||$(window).scrollTop() + $(window).height() > $(document).height() - 420 ) {
        nav.removeClass("mostrar");
        nav2.removeClass("mostrar");
 nav3.css("display", "none");
     // alert("1");
    
      }else {
      nav.addClass("mostrar");
      nav2.addClass("mostrar");
       
        nav3.css("display", "block");

    }
});

// hero Order Track

let hero = `


<style>
html {
  scroll-behavior: smooth;
}

#hero {
	position: relative;
	/* margin-top: 0; */
	display: flex;
	flex-direction: column;
	align-items: left;
	justify-content: center;
	text-align: bottom;
	color: #fff;
	height: 60vh;
	min-height: 25rem;
	width: 100%;
	overflow: hidden;
	z-index: 1;
	margin-left: 0%;
	clip: rect(90px, 630px, 485px, 290px);
	margin-top: 100px;
}

#hero::before{
 content: '';
 background: rgba(215, 215, 215, 0.6); /*OVERLAY*/
 position: absolute;
 height: 100%;
 width: 100%;
 z-index: 1;
 opacity: 0;
}
  
#hero h1{
  position: relative;
  font-size: 2.5rem; 
  z-index: 2;
  color:#fff;   
  text-transform: capitalize !important;
  letter-spacing: 0;
  line-height: 38px; 
  font-weight: 300;
}
  

  

  
p.breadcrumbs {
	text-align: center;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
  font-size: 18px;
	font-weight: 800;
}
p.breadcrumbs a {
	color: #fff;
	
	display: flex;
	align-items: center;
}
 #hero .title-top{
  margin-bottom: 00px;
  font-size: 1rem;

} 
  
#hero .title-top strong{
  position: relative; 
  font-size: 1.5rem;
  /*color:#fff;*/
  color:#fff;
  margin-top: 30px;
  z-index: 2; 
  left: 0;
  margin-bottom: 0px;
  margin-right: 0px;
}


@media (min-width: 767.98px) {
  
  
  #hero h1{
  font-size:3rem;  
  font-weight: 300 !important;
  line-height: 35px;
  text-align: center;
  }

  #hero .title-top{
  position: relative; 
  font-size: 1.5rem;
  /*color:#fff;*/
  color:#fff;
  margin-top: 30px;
  z-index: 2; 
  left: 0;
  margin-bottom: 20px;
}
  
  
    
#hero .title-top strong{
  position: relative; 
  font-size: 2.5rem;
  /*color:#fff;*/
  color:#fff;
  margin-top: 30px;
  z-index: 2; 
  left: 0;
  margin-bottom: 0px;
}
  



}
  
  
.content-hero{
 text-align: center;
 position: relative;
 z-index: 30;
  padding: 0px 20px;
  
}
  
  
 .content-hero-button{
 text-align: center;
 position: relative;
 z-index: 30;
 padding-right: 0px;
 margin-top: 0px;
}


#hero .video-container{
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  z-index: 0;
}

#hero .video-container video {
  min-height: 100%;
  min-width: 100%;
  width: 100%;
  object-fit: cover;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
}
  
  
#hero .video-container img {
	width: 100vw;
	height: 100%;
	position: relative;
	z-index: 1;
	object-position: bottom;
	object-fit: cover;
 object-position: 50% 50%;
}
  
  
#hero .title{
  height: 200px; 
  width: auto;
  
}
  



@media (min-width: 767.98px) {
  
  .content-hero{
 text-align: right;
 padding-left: 0px;
 margin-right: 0px;

 }

  
#hero .title{
  height: 400px; 
  width: auto;
  
}

}
  

  
.tooltip-inner {
  background-color: white;
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.2);
  color: grey;
  padding: 5px 10px;
}


.bs-tooltip-top .arrow::before {
  border-top-color: white;
}
  
  #hero .title-section {
	font-size: 35px;
	text-shadow: 2px 2px 2px #4c4b4b;
  color: #fff !important;
}
 #hero .title-section span {
	color: #fff;
}
  .content-title.title-subpages {
	margin-bottom: 0;
}
  .breadcrumbs i {
	font-size: 7px;
	margin: 0 5px;
}

  .deco-bottom-hero {
	position: absolute;
	z-index: 0;
	opacity: 0.4;
	/* bottom: 0; */
	filter: brightness(0) invert(1);
	/* rotate: -102deg; */
	bottom: -90px;
	left: -37px;
	height: 385px;
	transform: scaleY(-1);
}
 .deco-top-hero {
	position: absolute;
	z-index: 0;
	opacity: 0.4;
	/* bottom: 0; */
	filter: brightness(0) invert(1);
	/* rotate: 85deg; */
	top: -71px;
	right: -38px;
	height: 385px;
	transform: scaleX(-1);
}
@media (max-width: 425px){
.deco-top-hero {
	opacity: 0;
}
}
</style>



<section id="hero"> 
  
	  <!-- INICIO VIDEO DE FONDO -->
	   <div class="video-container">
           <img src="https://cdn.shopify.com/s/files/1/0694/6314/6794/files/the-cowgirl-fashion-woman_2.jpg?v=1675319733" loading="lazy" alt="Hero Track"/>
	   </div>
      <!--FIN VIDEO DE FONDO-->
  <div class="text-hero">
<div class="container">
<div class="row ">
    <div class="col-md-12 content-hero" data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-offset="0" data-aos-duration="2000"> 
     <div class="content-title title-subpages">
        <h2 class="title-section">Track Order</h2>
      </div>
     <p class="breadcrumbs"><span><a href="/">Home  <i class="fa-solid fa-circle"></i> </a></span><span>Track Order</span></p>
    </div>
    <div class="col-md-12 mt-4 content-hero-button" data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-offset="0" data-aos-duration="2000">
    </div>
    <h1 class="d-none"> Track Your Order Delivery Status | The Cowboy Army</h1>
   <h5 class="d-none"> Cowboy Army </h5>
     <p class="d-none"> Follow the progress of your order today. Get the latest updates on your order and experience the authenticity of The Cowboy Army!</p>
</div>

</div>
  </div>


</section>
`
let url=window.location;

if(url.pathname == "/apps/17TRACK"){
  document.querySelector("#MainContent").insertAdjacentHTML('beforebegin', hero)
}